export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const RESET_ORGANIZATION = 'RESET_ORGANIZATION';

export const mutations = {
  [UPDATE_ORGANIZATION](state, organization) {
    state.organization = organization;
  },
  [RESET_ORGANIZATION](state) {
    state.organization = undefined;
  },
};
